// Deduplication of incoming message events by message.id and createdById
// Keeps a small TTL cache of processed message IDs to avoid double-dispatching
// Uses composite key of id:createdById to handle same id with different creators
const PROCESSED_MESSAGE_TTL_MS = 1 * 60 * 1000 // 1 minute
const PROCESSED_MESSAGE_MAX = 1000
const processedMessageIds = new Map<string, number>()

const pruneProcessedMessageIds = (now: number) => {
  // Remove expired entries
  for (const [id, ts] of processedMessageIds) {
    if (now - ts > PROCESSED_MESSAGE_TTL_MS) {
      processedMessageIds.delete(id)
    } else {
      break
    }
  }
  // Enforce max size (FIFO eviction)
  while (processedMessageIds.size > PROCESSED_MESSAGE_MAX) {
    const firstKey = processedMessageIds.keys().next().value
    if (firstKey === undefined) break
    processedMessageIds.delete(firstKey)
  }
}

export const hasProcessedMessage = (id: string | number | undefined, createdById?: string): boolean => {
  if (!id && id !== 0) return false
  // Create composite key from id and createdById
  const key = createdById ? `${id}:${createdById}` : String(id)
  const now = Date.now()
  pruneProcessedMessageIds(now)
  if (processedMessageIds.has(key)) {
    return true
  }
  processedMessageIds.set(key, now)
  return false
}

export const resetProcessedMessages = (): void => {
  processedMessageIds.clear()
}
